import { Link } from "react-router-dom";
import { Check, Zap, Star, Crown } from "lucide-react";

const PLANS = [
  { name: "Gratuito", price: "R$ 0", icon: null, features: ["3 anúncios/mês", "Busca no mapa"] },
  { name: "Plus", price: "R$ 19,90", icon: Zap, features: ["10 anúncios/mês", "2 destaques"] },
  { name: "Pro", price: "R$ 29,90", icon: Star, highlight: true, features: ["25 anúncios/mês", "10 destaques", "Selo verificado"] },
  { name: "Ultra", price: "R$ 39,90", icon: Crown, features: ["Anúncios ilimitados", "30 destaques", "Suporte prioritário"] },
];

export default function PlansHighlight() {
  return (
    <section className="py-16 px-4 bg-secondary">
      <div className="container mx-auto max-w-5xl">
        <h2 className="text-3xl font-heading font-bold text-center mb-2">Escolha seu plano</h2>
        <p className="text-center text-muted-foreground mb-10">Anuncie de graça ou destaque-se com um plano pago.</p>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {PLANS.map((p) => {
            const Icon = p.icon;
            return (
              <div key={p.name} className={`bg-card border-2 rounded-2xl p-5 flex flex-col ${p.highlight ? "border-primary shadow-lg" : "border-border"}`}>
                {p.highlight && <span className="text-[10px] font-bold text-primary-foreground bg-primary px-2 py-0.5 rounded-full self-start mb-2">Popular</span>}
                <div className="flex items-center gap-1.5 mb-1">
                  {Icon && <Icon className="h-4 w-4 text-primary" />}
                  <h3 className="font-heading font-bold">{p.name}</h3>
                </div>
                <p className="text-2xl font-bold mb-3">{p.price}<span className="text-xs font-normal text-muted-foreground">/mês</span></p>
                <ul className="space-y-1.5 flex-1">
                  {p.features.map((f) => (
                    <li key={f} className="flex items-start gap-1.5 text-xs text-muted-foreground">
                      <Check className="h-3.5 w-3.5 text-primary shrink-0 mt-0.5" /> {f}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
        <div className="text-center mt-8">
          <Link to="/planos">
            <button className="bg-primary text-primary-foreground hover:bg-primary/90 font-semibold px-8 py-3 rounded-xl">
              Ver todos os planos →
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
}
